import { atom } from "jotai";
import { createNotificationSetter } from "../notifications";

export const handleImageUploadStartSetter = atom(
  null,
  (_get, set, message: string = "Uploading image... hang tight.") => {
    set(createNotificationSetter, {
      type: "info",
      message,
      timeout: 8000,
    });
  },
);

handleImageUploadStartSetter.debugLabel = "handleImageUploadStartSetter";
